import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { CheckCircle2, Utensils, Scale, MessageSquare, TrendingUp } from 'lucide-react';

export default function WhatToDoNowPopup({ open, onClose }) {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-hidden flex flex-col">
        <DialogHeader>
          <div className="flex items-center justify-center mb-4">
            <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center">
              <CheckCircle2 className="w-8 h-8 text-white" />
            </div>
          </div>
          <DialogTitle className="text-2xl text-center">
            🎉 What to do now
          </DialogTitle>
          <DialogDescription className="text-center text-base">
            You're all set! Here's your quick action plan to get started.
          </DialogDescription>
        </DialogHeader>
        
        <div className="space-y-4 py-4 overflow-y-auto flex-1">
          {/* Action 1 */}
          <div className="flex items-start gap-4 p-4 rounded-lg bg-blue-50 border border-blue-200">
            <div className="w-10 h-10 bg-blue-500 rounded-lg flex items-center justify-center flex-shrink-0">
              <Utensils className="w-5 h-5 text-white" />
            </div>
            <div className="flex-1">
              <h3 className="font-semibold text-gray-900 mb-1">1. Check your meal plan</h3>
              <p className="text-sm text-gray-700">
                Your personalized plan is ready. Review today's meals and start tracking what you eat.
              </p>
            </div>
          </div>

          {/* Action 2 */}
          <div className="flex items-start gap-4 p-4 rounded-lg bg-indigo-50 border border-indigo-200">
            <div className="w-10 h-10 bg-indigo-500 rounded-lg flex items-center justify-center flex-shrink-0">
              <Scale className="w-5 h-5 text-white" />
            </div>
            <div className="flex-1">
              <h3 className="font-semibold text-gray-900 mb-1">2. Log your weight daily</h3>
              <p className="text-sm text-gray-700">
                Weigh yourself each morning (empty stomach) and log it. Consistent data = better adjustments.
              </p>
            </div>
          </div>

          {/* Action 3 */}
          <div className="flex items-start gap-4 p-4 rounded-lg bg-purple-50 border border-purple-200">
            <div className="w-10 h-10 bg-purple-500 rounded-lg flex items-center justify-center flex-shrink-0">
              <MessageSquare className="w-5 h-5 text-white" />
            </div>
            <div className="flex-1">
              <h3 className="font-semibold text-gray-900 mb-1">3. Complete your weekly check-in</h3>
              <p className="text-sm text-gray-700">
                Every Wednesday-Thursday, submit a quick check-in. Your coach uses this to adjust your plan.
              </p>
            </div>
          </div>

          {/* Action 4 */}
          <div className="flex items-start gap-4 p-4 rounded-lg bg-green-50 border border-green-200">
            <div className="w-10 h-10 bg-green-500 rounded-lg flex items-center justify-center flex-shrink-0">
              <TrendingUp className="w-5 h-5 text-white" />
            </div>
            <div className="flex-1">
              <h3 className="font-semibold text-gray-900 mb-1">4. Track your progress</h3>
              <p className="text-sm text-gray-700">
                Watch your weight trend over time in the Progress section. Stay consistent and trust the process!
              </p>
            </div>
          </div>
        </div>

        <div className="pt-4 border-t flex-shrink-0">
          <p className="text-sm text-gray-600 text-center mb-4">
            💬 Need help? Message your coach anytime from the Messages tab.
          </p>
          <Button 
            onClick={onClose}
            className="w-full bg-gradient-to-r from-blue-500 to-purple-600 hover:from-blue-600 hover:to-purple-700 text-white"
          >
            Got it, let's start!
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
